import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { fallbackServices } from '../../data/fallbackData';
import { serviceTitle, serviceShort } from '../../utils/serviceDisplay';
import { enrichServicesFromApi } from '../../utils/enrichServicesFromApi';
import api from '../../api';
import './Services.css';

const Services = ({ onServiceNavigate }) => {
  const { t, lang } = useTranslation();
  const [services, setServices] = useState(fallbackServices);

  useEffect(() => {
    api.get('/api/services')
      .then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setServices(enrichServicesFromApi(res.data));
        }
      })
      .catch(() => {
      });
  }, []);

  return (
    <section id="services" className="section section-gray">
      <div className="container">
        <h2 className="section-title">{t('services.title')}</h2>
        <p className="section-subtitle">{t('services.subtitle')}</p>
        <div className="services__grid">
          {Array.isArray(services) && services.map((service, index) => (
            <button
              type="button"
              key={service.id || index}
              className="services__card"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => onServiceNavigate?.(service.slug)}
            >
              <div className="services__card-icon">{service.icon || '🔧'}</div>
              <h3 className="services__card-title">{serviceTitle(service, lang)}</h3>
              <p className="services__card-text">{serviceShort(service, lang)}</p>
              <span className="services__card-link">{t('services.more')}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;